import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetAccessPointsByLocationMutation } from '../../services/locations/locationsService';
import { Header } from '../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader,
  ContainerTable
} from '../../components/layout/main/mainStyles';
import Strings from '../../i18n';
import { AccessPointTable } from '../../templates/accessPoint/accessPoint';
import { MultipleAccessPoint } from '../../templates/accessPoint/multipleAccessPoint/multipleAccessPoint';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import { RightSideBar } from '../../components/layout/rightSideBar/rightSideBar';

export const AccessPointsView = () => {
  const { locationId } = useParams();
  const [selectedAccessPoint, setSelectedAccessPoint] = useState([]);
  const [openSideBar, setOpenSideBar] = useState(false);

  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.addScene
  );
  const [getAccessPointsByLocation, { isSuccess, data }] =
    useGetAccessPointsByLocationMutation();

  useEffect(() => {
    if (locationId) {
      getAccessPointsByLocation(+locationId);
    }
  }, [locationId]);

  const reloadTable = () => {
    if (locationId) {
      getAccessPointsByLocation(+locationId);
    }
  };

  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  useEffect(() => {
    if (selectedAccessPoint.length > 0) {
      openRightSideBarForMethod(viewRightSideBarEnum.multipleAccessPointDelete);
    }
  }, [selectedAccessPoint]);

  const switchComponentToShowRightSideBar = () => {
    switch (sideBarOpenFor) {
      case viewRightSideBarEnum.multipleAccessPointDelete:
        return (
          <MultipleAccessPoint
            selectedAccessPoint={selectedAccessPoint}
            setSelectedAccessPoint={setSelectedAccessPoint}
            setOpenSideBar={setOpenSideBar}
            reloadTable={reloadTable}
          />
        );
      default:
        return <p />;
    }
  };

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left" />
            <div className="col-6 col-sm-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.accessPoints.accessPoints}
              </StyledTitleHeader>
            </div>
            <div className="col-5 col-sm-4 text-right" />
          </div>
        </StyledHeaderContainer>
      </Header>
      <ContainerTable component="main">
        <AccessPointTable
          data={data || []}
          setSelectedAccessPoint={setSelectedAccessPoint}
          selectedAccessPoint={selectedAccessPoint}
        />
        <RightSideBar
          open={openSideBar}
          onMenuClose={() => {
            setOpenSideBar(false);
          }}
        >
          {switchComponentToShowRightSideBar()}
        </RightSideBar>
      </ContainerTable>
    </>
  );
};
